import {
    DEALERCASHLIFTINGLIST_SUCCESS,
    DEALERCASHLIFTINGLIST_FAILED,
    RESET_DEALERCASHLIFTINGLIST,
    LOADING_DEALERCASHLIFTINGLIST,
    NETWORK_ERROR_DEALERCASHLIFTINGLIST
} from "../types/index";
import { dealerServices } from "../../config/axios";

const resetDealerCashLiftingList = () => {
    return { type: RESET_DEALERCASHLIFTINGLIST };
};

const dealerCashLiftingList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERCASHLIFTINGLIST });
    await dealerServices
        .post("cashLiftingList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerCashLiftingListsuccess(res.data));
                    break;
                default:
                    dispatch(dealerCashLiftingListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERCASHLIFTINGLIST,
                payload: err
            });
        });
};
function dealerCashLiftingListsuccess(data) {
    return {
        type: DEALERCASHLIFTINGLIST_SUCCESS,
        payload: data
    };
}
function dealerCashLiftingListFailed(data) {
    return {
        type: DEALERCASHLIFTINGLIST_FAILED,
        payload: data
    };
}

export { resetDealerCashLiftingList, dealerCashLiftingList };
